import { gql } from 'graphql-request';

import { gqlClient } from 'graphql/gqlClient';
import { CompanyTag } from 'types/company.types';

type ListPaginatedCompanyTagsInput = {
  companyId: number;
  page: number;
  perPage?: number;
  searchText?: string;
};

type ListPaginatedCompanyTagsResponse = {
  items: CompanyTag[];
  total: number;
  page: number;
  perPage: number;
  pages: number;
};

export type CustomTab = {
  tagId: number;
  label: string;
};

type CreateCompanyTagInput = {
  name: string;
  description?: string;
};

type UpdateCustomTabsInput = {
  tabs: CustomTab[];
};

const LIST_MOST_SELECTED_COMPANY_TAGS = gql`
  query ListMostSelectedCompanyTags($companyId: Int!) {
    mostSelectedCompanyTags(companyId: $companyId) {
      id
      name
    }
  }
`;

const LIST_PAGINATED_COMPANY_TAGS = gql`
  query ListPaginatedCompanyTags(
    $companyId: Int!
    $page: Int!
    $perPage: Int = 10
    $searchText: String
  ) {
    paginatedCompanyTags(
      companyId: $companyId
      page: $page
      perPage: $perPage
      searchText: $searchText
    ) {
      items {
        id
        name
      }
      total
      page
      perPage
      pages
    }
  }
`;

const LIST_COMPANY_TAGS_AND_CUSTOM_TABS = gql`
  query ListCompanyTagsAndCustomTabs($searchText: String) {
    companyTags(searchText: $searchText) {
      id
      name
    }
    customTabs {
      tagId
      label
    }
  }
`;

const CREATE_COMPANY_TAG = gql`
  mutation CreateCompanyTag($input: CreateCompanyTagInput!) {
    createCompanyTag(input: $input) {
      ok
      companyTag {
        id
        name
      }
    }
  }
`;

const UPDATE_COMPANY_CUSTOM_TABS = gql`
  mutation UpdateCompanyCustomTabs($input: UpdateCompanyCustomTabsInput!) {
    updateCompanyCustomTabs(input: $input) {
      ok
      customTabs {
        tagId
        label
      }
    }
  }
`;

const companyTagsApi = {
  listMostSelected: async (companyId: number): Promise<CompanyTag[]> => {
    return gqlClient
      .request<{ mostSelectedCompanyTags: CompanyTag[] }>(LIST_MOST_SELECTED_COMPANY_TAGS, {
        companyId
      })
      .then((res) => res.mostSelectedCompanyTags);
  },
  listPaginated: async (
    input: ListPaginatedCompanyTagsInput
  ): Promise<ListPaginatedCompanyTagsResponse> => {
    return gqlClient
      .request<{ paginatedCompanyTags: ListPaginatedCompanyTagsResponse }>(
        LIST_PAGINATED_COMPANY_TAGS,
        input
      )
      .then((res) => res.paginatedCompanyTags);
  },
  listWithCustomTabs: async (
    searchText = ''
  ): Promise<{ companyTags: CompanyTag[]; customTabs: CustomTab[] }> => {
    return gqlClient.request(LIST_COMPANY_TAGS_AND_CUSTOM_TABS, { searchText });
  },
  create: async (input: CreateCompanyTagInput): Promise<CompanyTag> => {
    return gqlClient
      .request<{ createCompanyTag: { ok: boolean; companyTag: CompanyTag } }>(CREATE_COMPANY_TAG, {
        input
      })
      .then((res) => res.createCompanyTag.companyTag);
  },
  updateCustomTabs: async (input: UpdateCustomTabsInput): Promise<CustomTab[]> => {
    return gqlClient
      .request<{ updateCompanyCustomTabs: { ok: boolean; customTabs: CustomTab[] } }>(
        UPDATE_COMPANY_CUSTOM_TABS,
        { input }
      )
      .then((res) => res.updateCompanyCustomTabs.customTabs);
  }
};

export { companyTagsApi };
